/**
 * Kit de filtros operativos (Customer, POS, Catálogo, Stock, Informes).
 *
 * Variantes (`useOperationalFilterLayout`):
 * - mobile: segmentos + pickers apilados
 * - wide: chips + wideToolbarRow
 * - workspace: secciones con label y divider (web @960)
 */
export { OperationalFiltersCard } from './OperationalFiltersCard';
export { OperationalFiltersPanelShell } from './OperationalFiltersPanelShell';
export { OperationalFilterClearLink } from './OperationalFilterClearLink';
export { OperationalFiltersClearRow } from './OperationalFiltersClearRow';
export {
  CATALOG_FILTERS_COLLAPSED_STORAGE_KEY,
  POS_FILTERS_COLLAPSED_STORAGE_KEY,
  STOCK_FILTERS_COLLAPSED_STORAGE_KEY,
  PROMOTIONS_FILTERS_COLLAPSED_STORAGE_KEY,
  EXPENSES_FILTERS_COLLAPSED_STORAGE_KEY,
  EXPENSE_PAYMENTS_FILTERS_COLLAPSED_STORAGE_KEY,
  SALES_FILTERS_COLLAPSED_STORAGE_KEY,
  CUSTOMER_FILTERS_COLLAPSED_STORAGE_KEY,
} from './operationalFiltersCollapsedStorage';
export { OperationalFilterToggleChip } from './OperationalFilterToggleChip';
export { OperationalFilterDismissChip } from './OperationalFilterDismissChip';
export {
  useOperationalFilterLayout,
  OPERATIONAL_FILTER_COMPACT_BREAKPOINT,
  type OperationalFilterLayout,
  type OperationalFilterVariant,
} from './useOperationalFilterLayout';
export {
  OperationalFilterAvailabilityRow,
  OperationalFilterChipGroup,
  OperationalFilterChipScrollRow,
  OperationalFilterFieldLabel,
  OperationalFilterPickerRow,
  OperationalFilterSearchField,
  OperationalFilterSectionDivider,
  OperationalFilterSegmentedRow,
  type OperationalFilterOption,
} from './OperationalFilterPrimitives';
export { MastersListFiltersPanel, type MastersPageSize } from './MastersListFiltersPanel';
export { MasterFilterSheetModal, type MasterFilterOption } from './MasterFilterSheetModal';
export { MasterFilterCompactPicker } from './MasterFilterCompactPicker';
export {
  PosCatalogStockFiltersPanel,
  type PosCatalogStockFiltersMode,
} from './PosCatalogStockFiltersPanel';
export { operationalFilterStyles } from './operationalFilters.styles';
export { OperationalChipSelectRow } from './OperationalChipSelectRow';
export { OperationalHintIcon } from '../ui/OperationalHintIcon';
export { FilterSheetButton } from './FilterSheetButton';
export { FilterSheetModal } from './FilterSheetModal';
